import { AppContextProps } from "../AppContext";

import SelectDialogBase, { SelectDialogBaseProps } from "./SelectDialogBase";


export class SelectDialog {

  static Show(ctx: AppContextProps | null, message: string, title: string,
    width: string, options: any[], valueMember: string, displayMember: string,
    props?: Omit<SelectDialogBaseProps, 'open'>) {

    const dialog = ctx?.ShowDialog(SelectDialogBase, {
      title: title,
      width: width, //預設300
      options: options, //選項
      message: message, // 添加 message 屬性
      valueMember: valueMember,
      displayMember: displayMember, // 修正拼寫錯誤
      yesText: "執行",
      yesButtonProps: { variant: 'contained' },

      cancelText: "取消",
      cancelButtonProps: { color: 'inherit' },

      ...props,

      onDialogResult(e) { // 注意! 要放在 ...props 後面覆寫事件
        props?.onDialogResult?.(e);

        if (e.IsCancelClose !== true) {
          dialog?.destroy();
          return
        }
      },
    });
  }


}